// HashtagHashtag.jsx
import { redirect } from 'react-router';

export const loader = async ({ params }) => {
  const { hashtag } = params;
  throw redirect(`/hashtag/${hashtag}/flix`, 308);
};

const HashtagHashtagRoute = () => {
  return null;
};

export default HashtagHashtagRoute;
